import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaB_Van_Left: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="95"
      height="137"
      viewBox="0 0 95 137"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_van_left"
          x="0"
          y="0"
          width="95"
          height="137"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_b_van_left)">
        <path
          d="M1.00586 4.05273C52.0417 -1.26433 77.8024 1.53053 88.8203 3.72656L93.9336 134.657C75.8291 133.423 62.7257 132 1.90625 135.175L1.00586 4.05273Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
